import React from 'react';
import { Route, Link, Switch } from 'react-router-dom';
import NavList from 'Components/nui/NavList';
import { matchUrl, routeUrl } from '~/router';
import { FormattedMessage } from 'react-intl';
import { usePermissions } from '~/hooks/usePermissions';

export default () => {
  const { canCreateTender } = usePermissions();

  return (
    <Switch>
      <Route path={matchUrl('tender-new')} />
      <Route path={matchUrl('tender-view')} />
      <Route>
        {canCreateTender && (
          <Link
            className="nui-button nui-primary new-tender"
            title="Create a new tender"
            to={routeUrl('tender-new')}
          >
            <FormattedMessage
              id="tender-list-button-new-tender"
              description="Label for `new tender` button on tender list page"
              defaultMessage="New tender"
            />
          </Link>
        )}
        <NavList>
          <NavList.Tab
            exact
            url={routeUrl('tender-overview')}
            path={matchUrl('tender-overview')}
          >
            <FormattedMessage
              id="tender-list-tab-overview"
              description="Label for `Overview` tab on tender list page"
              defaultMessage="Overview"
            />
          </NavList.Tab>
          <NavList.Tab
            url={routeUrl('tender-history')}
            path={matchUrl('tender-history')}
          >
            <FormattedMessage
              id="tender-list-tab-history"
              description="Label for `History` tab on tender list page"
              defaultMessage="History"
            />
          </NavList.Tab>
        </NavList>
      </Route>
    </Switch>
  );
};
